module.exports = __webpack_public_path__ + "static/img/1.deca963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R22/1.jpg
// module id = 03P1
// module chunks = 1